import { isDefined } from "@clipboard-health/util-ts";

/**
 * Extracts the attributes from the live activity id
 * @param liveActivityId - The live activity id
 * @returns The worker id, shift id, and device id
 */
export function getAttributesFromLiveActivityId(liveActivityId: string) {
  const [workerId, shiftId, ...deviceIdParts] = liveActivityId.split("-");
  const deviceId = deviceIdParts.join("-");

  if (!isDefined(workerId) || !isDefined(shiftId) || !isDefined(deviceId)) {
    throw new Error(
      `Invalid liveActivityId format: ${liveActivityId}. Expected format: workerId-shiftId-deviceId`
    );
  }

  return { workerId, shiftId, deviceId };
}
